module.exports = __webpack_public_path__ + "media/img/pages/profile/lgt ger 10-34f134e7d12099735056f734e1786868.jpg";